<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/leave">Leave</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="mt-3 text-right" v-if="model.status === 'Requested'">
                <b-button variant="danger" class="btn-sm mr-2" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon> Reject
                </b-button>
                <b-button variant="success" class="btn-sm" @click="showModal('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon> Approve
                </b-button>
            </b-col>
            <b-col>
            <b-button v-if="getDateCount(model.startDate) >= nowDate & model.status === 'Approved'" variant="danger" class="btn-sm mr-2 float-right mt-3" @click="showModal('reject')">
                <font-awesome-icon icon="times-circle"></font-awesome-icon> Reject
            </b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"/>
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <b-form class="mt-4 mx-2" v-else>
            <b-row>
                <b-col md="6">
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Requested By</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.requestedBy.name !== null ? model.requestedBy.name : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row v-if="model.statusValue !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.statusText}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.statusValue }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Type</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.leaveType }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Days</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.days }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Status</label>
                        </b-col>
                        <b-col md="8">
                            <p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Exceed Quota of Leave</label>
                        </b-col>
                        <b-col md="8">
                            <p v-if="model.quotaExceed > null" style="color:red!important; font-weight:bold!important;">{{ formatDays(model.quotaExceed) }} Day(s)</p>
                            <p v-else>-</p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row v-if="model.statusTime !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.statusTextTime}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.statusTime }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Start</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.startDate !== null ? getDateTime(model.startDate) : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">End</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.endDate !== null ? getDateTime(model.endDate) : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Created</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.createdAt }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Note</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.note !== null ? model.note : '-' }}</p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mt-3 mb-3" v-if="model.leaveType === 'Annual Leave'">
            </b-row>
            <b-row v-else>
                <b-col>
                    <h5 class="pb-3 mt-2 mb-0">Photo</h5>
                </b-col>
                <b-col md="12">
                    <b-row v-if="model.leavePhotoList.length === 0">
                        <b-col md="3">
                            <p class="text-secondary text-center border border-radius p-5"><i>No Photo Submitted</i></p>
                        </b-col>
                    </b-row>
                    <viewer :images="model.leavePhotoList" v-else>
                        <b-row>
                            <b-col md="3 mb-4" v-for="(src, index) in model.leavePhotoList" :key="index">
                                <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src" class="img-responsive" width="300" height="200"/>
                            </b-col>
                        </b-row>
                    </viewer>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 class="mb-3 mt-1">Leave Status History</h5>
                </b-col>
                <b-col md="12">
                    <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" width="100">Status</th>
                                <th scope="col" width="250">Changed By</th>
                                <th scope="col">Note</th>
                                <th scope="col" width="200">Time</th>
                            </tr>
                        </thead>
                        <tbody v-if="leaveHistoryStatusList.length > 0">
                        <tr v-for="leave in leaveHistoryStatusList" :key="leave.uuid">
                            <td><b-badge :variant="getStatusColor(leave.status)">{{leave.status}}</b-badge></td>
                            <td>{{leave.changedBy}}</td>
                            <td>{{leave.note !== null ? leave.note : '-'}}</td>
                            <td>{{leave.createdAt !== null ? getDateTime(leave.createdAt) : '-'}}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="9" class="text-center">there's no data</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
        <b-modal id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">{{type}} Leave</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatus(type)">
                <div class="d-block">
                    <!-- <label for="" class="labels">Name</label>
                    <b-form-input v-model="formData.name" readonly id="field-type"></b-form-input><br> -->
                    <label for="" class="labels">Note</label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'leave-show',
        data () {
            return {
                nowDate: this.getDateCount(new Date()),
                startLeave: null,
                isLoading: false,
                apiUrl: {
                    leave: window.AppConfig.apiUrl + 'leave',
                    leavePhoto: window.AppConfig.apiUrl + 'leave-photo',
                    leaveHistoryStatus: window.AppConfig.apiUrl + 'leave-history-status'
                },
                type: null,
                formData: {
                    name: null,
                    note: null
                },
                // mainProps: { blank: true, width: 75, height: 75, class: 'm1' },
                model: {
                    days: '',
                    requestedBy: '',
                    startDate: '',
                    endDate: '',
                    status: '',
                    note: '',
                    createdAt: '',
                    changedBy: '',
                    leavePhotoList: [],
                    leaveType: null,
                    statusValue: '',
                    statusTime: '',
                    quotaExceed: ''
                },
                leaveHistoryStatusList: []
            }
        },
        mounted () {
            this.getDetail()
            this.getHistoryStatus()
        },
        methods: {
            showModal (type) {
                this.formData.note = null
                this.formData.name = this.model.requestedBy.name
                this.type = type
                this.$bvModal.show('bv-modal-example')
            },
            doChangeStatus (type) {
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'leave-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    this.formData.note = null
                    this.$bvModal.hide('bv-modal-example')
                    this.getDetail()
                    this.getHistoryStatus()
                    if (type === 'reject') {
                        this.$store.dispatch('notification/success', 'Leave has been ' + type + 'ed')
                    } else {
                        this.$store.dispatch('notification/success', 'Leave has been ' + type + 'd')
                    }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.leave + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy : '-'
                    this.model.startDate = response.data.startDate !== null ? response.data.startDate : '-'
                    this.model.endDate = response.data.endDate !== null ? response.data.endDate : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.quotaExceed = response.data.quotaExceed !== null ? response.data.quotaExceed : '-'
                    this.model.createdAt = response.data.createdAt !== null ? this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm A') : '-'
                    this.model.days = response.data.days !== null ? response.data.days : '-' 
                    if (response.data.rejectedBy !== null) {
                        this.model.statusText = 'Rejected By'
                        this.model.statusTextTime = 'Rejected Time'
                        this.model.statusValue = response.data.rejectedBy
                        this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    if (response.data.approvedBy !== null) {
                        this.model.statusText = 'Approved By'
                        this.model.statusTextTime = 'Approved Time'
                        this.model.statusValue = response.data.approvedBy
                        this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    this.model.leavePhotoList = []
                    if (response.data.leavePhoto !== null) {
                        response.data.leavePhoto.forEach(data => {
                            this.model.leavePhotoList.push(data.url)
                        })
                    }
                    this.model.leaveType = response.data.leaveType !== null ? response.data.leaveType.name : '-'
                    this.startLeave = response.data.startDate !==null ? this.getDateCount(response.data.startDate) : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            formatDays(value) {
                let val = (value/1).toFixed(1).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            getHistoryStatus () {
                this.isLoading = true
                this.$http.get(this.apiUrl.leaveHistoryStatus + '?leave_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
                    this.leaveHistoryStatusList = []
                    response.data._embedded.leaveHistoryStatus.forEach(data => {
                        this.leaveHistoryStatusList.push(data)
                    })
                    this.isLoading = false
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            /**
             * pakai fungsi ini untuk memformat tanggal contoh '20211119' dan
             *  membuat logic perbandingan antara tanggal hari ini dan yang akan datang
             * 
             */
            getDateCount(value){
                if(value !==null){
                    return this.$moment(value).format('YYYYMMDD')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Rejected':
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            hasRole (name) {
              let temp = false
              name.forEach((key) => {
                if (this.$store.getters['account/accountData'].role == key){
                  temp = true
                }
              })
              return temp
            }
        }
    }
</script>